import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { ExperienceInsertService } from '../../service/experience-insert/experience-insert.service';

@Component({
	selector: 'app-experience-insert',
	templateUrl: './experience-insert.component.html',
	providers: [
		ExperienceInsertService,
		HttpModule
	]
})
export class ExperienceInsertComponent implements OnInit {

	private token;
	public permissoes: any[] = [];
	experience: FormGroup;
	Descricao: string = "";
	statusExperience: boolean;

	constructor(fb: FormBuilder, private experienceInsertService: ExperienceInsertService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.experience = fb.group({
			'Descricao': [null, Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

	addExperience(value: any) {
		console.log(value);
		this.experienceInsertService.insertExperience(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Experiência cadastrada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/experiencia');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/experiencia');
	}

}


// WEBPACK FOOTER //
// ./src/app/experience/component/experience-insert/experience-insert.component.ts